import GalleryDetails from "./GalleryDetails";

export default GalleryDetails;
